<template>
    <div class="collectRecord">
        <div class="collect-wrap">
            <h2>
                我的收藏记录
            </h2>
            <div class="main-container">
                <ul v-show="showed">
                    <li @click.stop="Seedetails(item)"
                        v-for="(item) in data"
                        :key="item.index">
                        <section class="main-part">
                            <div><span class="jiahei">{{item.name}}</span><span v-show="item.delFlag=='1'"
                                      class="biaoqian">职位已失效</span></div>
                            <div>
                                <dl>
                                    <dd>
                                        <span>地点：</span>
                                        <span>{{item.address}}</span>
                                    </dd>
                                    <dd>
                                        <span>招聘人数：</span>
                                        <span>{{item.jobCount|person}}</span>
                                    </dd>
                                    <dd>
                                        <span>所属分类：</span>
                                        <span>{{item.positionName}}</span>
                                    </dd>
                                    <dd>
                                        <span>学历：</span>
                                        <span>{{item.educationName}}</span>
                                    </dd>
                                </dl>
                            </div>
                            <div>
                                发布日期:<span>{{item.pubDate|formatDateMinsss}}</span>
                            </div>
                        </section>
                        <section @click.stop="quxiaoshoucang(item)"
                                 class="collcet-img">
                            <div><i class="icon iconfont icon-shoucang"></i></div>
                            <div><span>取消收藏</span></div>
                        </section>
                    </li>
                </ul>
                <div v-show="!showed"
                     class="null">
                    <img src="@/assets/images/zanwujilu@2x.png" />
                    <p>暂无数据</p>
                </div>
            </div>
        </div>
        <div class="block">
            <el-pagination background=""
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page.sync="ruleForm.pageIndex"
                           :page-sizes="[6, 15, 30]"
                           :page-size="ruleForm.pageSize"
                           layout="total,sizes,prev, pager, next, jumper"
                           :total="ruleForm.total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { querymycollection, cancelmycollection } from "@/api/apiall";
import router from "@/router";
import { getUsers } from "@/api/login";
export default {
    data() {
        return {
            showed: true,
            data: [],
            ruleForm: {
                data: {
                    userId: ""
                },
                pageIndex: 1,
                pageSize: 6,
                total: 0
            },
            datalist: {
                id: "",
                userId: "",
                positionId: ""
            }
        };
    },
    mounted() {
        this.getUserId();
    },
    methods: {
        getUserId() {
            if (
                sessionStorage.getItem("userId") == null ||
                sessionStorage.getItem("userId") == undefined
            ) {
                getUsers().then(res => {
                    this.ruleForm.data.userId = res.userId;
                    this.search();
                });
            } else {
                this.ruleForm.data.userId = sessionStorage.getItem("userId");
                this.search();
            }
        },
        search() {
            querymycollection(this.ruleForm).then(res => {
                if (res.status === 2000) {
                    if (res.data.total > 0) {
                        this.showed = true;
                    } else {
                        this.showed = false;
                    }
                    this.data = res.data.rows;
                    this.ruleForm.total = res.data.total;
                }
            });
        },
        handleCurrentChange(val) {
            this.ruleForm.pageIndex = val;
            this.search();
        },
        handleSizeChange(val) {
            this.ruleForm.pageSize = val;
            this.search();
        },
        quxiaoshoucang(item) {
            this.datalist.id = item.id.toString();
            this.datalist.userId = sessionStorage.getItem("userId");
            this.datalist.positionId = item.positionId;
            cancelmycollection(this.datalist).then(res => {
                if (res.status === 2000) {
                    if (res.data == "操作成功") {
                        this.$message({
                            message: "取消收藏成功",
                            type: "success"
                        });
                        this.search();
                    } else {
                        this.$message({
                            message: res.data,
                            type: "warning"
                        });
                    }
                }
            });
        },
        Seedetails(item) {
            if (item.delFlag == "1") {
                this.$message({
                    message: "此职位已失效",
                    type: "warning"
                });
            } else {
                let routeUrl = router.resolve({
                    path: "/Jobdetails",
                    query: {
                        contentid: item.positionId
                    }
                });
                window.open(routeUrl.href, "_blank");
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.collectRecord {
    .collect-wrap {
        width: 1200px;
        margin: 0 auto;
        background-color: #f5f6f7;
        padding-bottom: 70px;
        > h2 {
            color: #000024;
            font-size: 32px;
            font-weight: bold;
            padding: 40px 0;
        }
        .main-container {
            .null {
                width: 185px;
                height: 185px;
                margin: 200px auto;
                img {
                    width: 100%;
                }
                p {
                    font-size: 13px;
                    color: #ccc;
                    margin-top: 10px;
                    text-align: center;
                }
            }
            ul {
                list-style: none;
                margin: 0;
                padding: 0;
                li {
                    background-color: #fff;
                    padding: 30px;
                    transition: all 0.3s ease-out;
                    &:hover {
                        transform: translateY(-20px);
                    }
                    .main-part {
                        display: inline-block;
                        > div:first-child {
                            .jiahei {
                                cursor: pointer;
                                color: #000000;
                                font-size: 24px;
                                font-weight: bold;
                                text-decoration: none;
                                &:hover {
                                    color: #fabe00;
                                }
                            }
                        }
                        > div:nth-child(2) {
                            dl {
                                dd:first-child {
                                    padding-right: 15px;
                                }
                                dd {
                                    font-size: 16px;
                                    color: #333333;
                                    display: inline-block;
                                }
                                dd + dd {
                                    border-left: 1px solid #666666;
                                    padding: 0 15px;
                                }
                            }
                        }
                        div + div {
                            margin-top: 20px;
                        }
                        > div:last-child {
                            font-size: 16px;
                            color: #666666;
                        }
                        .biaoqian {
                            position: relative;
                            top: -6px;
                            left: 20px;
                            display: inline-block;
                            width: 100px;
                            text-align: center;
                            height: 20px;
                            background-color: #ccc;
                            border-radius: 2px;
                        }
                        .biaoqian::after {
                            content: "";
                            position: absolute;
                            left: 0;
                            bottom: -3px;
                            border-width: 2px;
                            border-style: solid;
                            border-color: #ccc transparent transparent #ccc;
                        }
                    }
                    > .collcet-img {
                        display: inline-block;
                        margin-top: 15px;
                        float: right;
                        .icon-shoucang {
                            font-size: 32px;
                            color: #666666;
                        }
                        > div {
                            text-align: center;
                        }
                        > div:last-child {
                            margin-top: 15px;
                            cursor: pointer;
                            &:hover {
                                color: #fabe00;
                            }
                        }
                    }
                }
                li + li {
                    margin-top: 30px;
                }
            }
        }
    }
    .block {
        text-align: center;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>